import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import LanguageDropdown from '@client/components/dropdowns/languageDropdown/LanguageDropdown';
import ReactLink from '@client/components/links/reactLink/ReactLink';
import Flex from '@client/components/flex/Flex';
import whiteSparksLogo from '@client/shared/images/logo-white.png';
import blackSparksLogo from '@client/shared/images/logo@2x.png';
import whiteMenuIcon from '@client/shared/icons/menu.svg';
import blackMenuIcon from '@client/shared/icons/menu-black.svg';
import cross from '@client/shared/icons/cross.svg';
import allerLogo from '@client/shared/images/landingPageAssets/aller-logo-black.svg';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './navMenu.scss';

const MainNav = ({ hasWhiteLogo, hasWhiteIcon }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation(['menu', 'common']);
  const location = useLocation();

  function onToggleMenu() {
    setIsMenuOpen(!isMenuOpen);
  }

  const isTermsPage = location.pathname.includes('terms');

  return (
    <>
      <Flex spaceBetween flexNr={1} className={styles.mainNav}>
        <ReactLink to={'/'}>
          <img
            src={hasWhiteLogo ? whiteSparksLogo : blackSparksLogo}
            alt={'Aller Sparks logo'}
            className={classNames(styles.hideOnTablet, styles.logo)}
          />
          <img
            src={blackSparksLogo}
            alt={'Aller Sparks logo'}
            className={classNames(styles.hideOnMobile, styles.logo)}
          />
        </ReactLink>
        {!isTermsPage && (
          <Flex>
            <LanguageDropdown light={hasWhiteIcon} />
            <img
              src={hasWhiteIcon ? whiteMenuIcon : blackMenuIcon}
              alt={'menu'}
              className={styles.menuIcon}
              onClick={onToggleMenu}
            />
          </Flex>
        )}
      </Flex>
      {isMenuOpen && (
        <Flex column className={styles.menuOverlay}>
          <Flex spaceBetween>
            <img
              src={whiteSparksLogo}
              alt={'Aller Sparks logo'}
              className={styles.logo}
            />
            <Flex alignCenter>
              <LanguageDropdown light={hasWhiteIcon} />
              <img
                src={cross}
                alt={'menu'}
                className={styles.crossIcon}
                onClick={onToggleMenu}
              />
            </Flex>
          </Flex>
          <Flex alignCenter justifyCenter flexNr={1} column>
            <ReactLink to={'/'}>
              <span className={styleHelper.landingH6} onClick={onToggleMenu}>
                {t('menu:start')}
              </span>
            </ReactLink>
            <ReactLink to={'/advertiser'} className={styles.menuEntry}>
              <span className={styleHelper.landingH6} onClick={onToggleMenu}>
                {t('menu:advertise')}
              </span>
            </ReactLink>
          </Flex>
          <div className={styles.allerMediaLogoContainer}>
            <a
              className={styles.allerLink}
              href={t('common:allerLink')}
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src={allerLogo}
                alt={'Aller media logo'}
                className={styles.allerMediaLogoInverted}
              />
            </a>
          </div>
        </Flex>
      )}
    </>
  );
};

MainNav.propTypes = {
  hasWhiteIcon: PropTypes.bool,
  hasWhiteLogo: PropTypes.bool,
};

export default MainNav;
